import { render } from "./auth-base-login.vue?vue&type=template&id=254deb01&scoped=true&ts=true"
import script from "./auth-base-login.vue?vue&type=script&lang=ts"
export * from "./auth-base-login.vue?vue&type=script&lang=ts"

import "./auth-base-login.vue?vue&type=style&index=0&id=254deb01&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254deb01"]])

export default __exports__